function ValidaRut(value)
{
	var valido = false // Flag que indica si el rut es valido o no
	var pos = value.indexOf("-") // Buscamos el guion para quitar el digito verificador del numero de rut
	var numero = value.substr(0, pos) // Numero de Rut
	var dv = value.substr(pos + 1, 1).toUpperCase() // Digito Verificador

	var modulo = 11
	var suma = 0
	var serie = 2
	for (var i = numero.length - 1; i >= 0; i--)
	{
		suma += parseInt(numero.charAt(i)) * serie	
		serie++

		if (serie > 7)
			serie = 2
	}

	var resto = suma % modulo
	var diferencia = modulo - resto

	var comparador = ""
	if (diferencia == 11)
		comparador = "0"	
	else if (diferencia == 10)
		comparador = "K"
	else
		comparador = diferencia.toString()


	return comparador == dv
}

export default ValidaRut
